export const xs = 576;
export const sm = 768;
export const md = 1020;
export const lg = 1278;
export const xl = 1440;

export default {
	xs,
	sm,
	md,
	lg,
	xl
};
